import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { AiFillDelete, AiOutlineUndo, AiFillEye } from "react-icons/ai";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import { API_BASE_URL } from "../../config";
import Header from "../Header";
import LoanPOPUP from "./LoanPOPUP";

export default function Loan() {
  const { logout } = useAuth();
  const [alltotal_inside, setalltotal_inside] = useState('0');
  const [alltotal_outside, setalltotal_outside] = useState('0');
  const [allremaining_balance, setallremaining_balance] = useState('0');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [savedData, setSavedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isRole, setIsRole] = useState("false");
  const navigate = useNavigate();

  const [credentials] = useState({
    token: localStorage.getItem("authToken"),
  });

  const fetchfirstdata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/loan`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        const sortedData = response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setProducts(sortedData);
        setFilteredProducts(sortedData);
        setSavedData(response.data.namesuggestions);

        setalltotal_inside(response.data.all_total_inside);
        setalltotal_outside(response.data.all_total_outside);
        setallremaining_balance(response.data.all_remaining_balance);
      }
    } catch (err) {
      logout();
      navigate("/");
    }
  };

  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      fetchfirstdata();
      const role = localStorage.getItem("role");
      if (role) {
        setIsRole(role);
      }
    }
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = products.filter((entry) =>
      entry.name.toLowerCase().includes(query)
    );
    setFilteredProducts(filtered);
  };

  return (
    <>
      <Header />
      <div className="du-detils">
        <div className="container">
            <div className="col-md-12">
              <Link>
                <LoanPOPUP
                  fetchfirstdata={fetchfirstdata}
                  savedData={savedData}
                />
              </Link>
            </div>
      
          <div className="product-form">
            <div className="row">
              <div className="col-md-4 col-12  wi-33p">
                <label>Inside Total : {alltotal_inside}</label>
              </div>
              <div className="col-md-4 col-12  wi-33p">
                <label>Outside Total : {alltotal_outside} </label>
              </div>
              {/* <div className="col-md-4 col-12  wi-33p">
                <label>Total : {allremaining_balance}</label>
              </div> */}
            </div>
          </div>
          <div className="show-detils">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={handleSearch}
                className="form-control"
              />
            </div>
            {filteredProducts.length > 0 ? (
              <table className="table table-dark table-striped">
                <thead>
                  <tr>
                    {/* <th>Actions</th> */}
                    <th>Name</th>
                    <th>Inside</th>
                    <th>Outside</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.map((entry, i) => (
                    <tr key={i}>
                      {/* <td>                    
                        <Link
                          className="btn btn-info bt-icon-tab"
                          to={`/creditdetail/${entry.customer_id}`}
                        >
                          <AiFillEye />
                        </Link>
                      </td> */}
                      <td>{entry.name}</td>
                      <td>{entry.total_outside}</td>
                      <td>{entry.total_inside}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No records found</p>
            )}
          </div>
        </div>
      </div>
      <Header />
    </>
  );
}
